import Link from "next/link";
import { Spinner } from "react-bootstrap";
import { AANavDropdown, NavIcon } from "@bagel-web/components";
import { WhoAmI } from "types/app";

const SwitchProject = ({
  whoami,
  disabled = false,
  onSwitchProject,
}: {
  whoami: WhoAmI;
  disabled?: boolean;
  onSwitchProject: (id: string) => void;
}) => {
  if (disabled) {
    return (
      <>
        <span>Project</span>
        <Spinner className="ms-2" size="sm" />
      </>
    );
  }
  if (!whoami.project) {
    return (
      <Link href="/projects">
        <NavIcon className="bi-folder-fill" />
        No Projects
      </Link>
    );
  }
  if (!whoami.projects || whoami.projects.length <= 1) {
    return (
      <>
        <NavIcon className="bi-folder-fill" />
        <span className="inline-block">{whoami.project?.name}</span>
      </>
    );
  }

  return (
    <AANavDropdown
      title={
        <>
          <NavIcon className="bi-folder-fill" />
          {whoami.project?.name}
        </>
      }
      disabled={disabled}
      align="end"
      placement="auto-start"
    >
      <AANavDropdown.Header>Projects</AANavDropdown.Header>
      {whoami.projects
        ?.toSorted((a, b) => a.name.localeCompare(b.name))
        .map((project) => {
          return (
            <AANavDropdown.Item
              key={project.id}
              as="button"
              onClick={() => onSwitchProject(project.id)}
            >
              {project.name}
            </AANavDropdown.Item>
          );
        })}
    </AANavDropdown>
  );
};

export default SwitchProject;
